//
import { client } from '../../graphql/client';
import { DeleteTenants } from '../../graphql/generated-queries/delete-tenants-queries';

export async function removeTenant(input) {
  try {
    return await client.mutate({ mutation: DeleteTenants, variables: { ids: [input.id] } });
  } catch (err) {
    console.error(err);
  }
}
